import { render, staticRenderFns } from "./event.vue?vue&type=template&id=10a44f75&scoped=true"
import script from "./event.vue?vue&type=script&lang=js"
export * from "./event.vue?vue&type=script&lang=js"
import style0 from "./event.vue?vue&type=style&index=0&id=10a44f75&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a44f75",
  null
  
)

export default component.exports